module.exports = __webpack_public_path__ + "img/login_tab03_05.d952d551.png";